import { UserFormValues } from '../../types'

interface Args {
  formValues: UserFormValues
  userConfiguration: uui.domain.UserConfiguration
  weekStartsOn: uui.domain.WeekStartsOn
  uiSettings?: uui.domain.server.rm.UserUISettings
}

type CourierFilterEntry = {
  driverIds: string[]
  vehicleIds: string[]
}

export function createUpdateUserPayload(
  args: Args,
): uui.domain.actions.rpc.user.UpdateUserAction['payload'] {
  const { formValues, userConfiguration, uiSettings, weekStartsOn } = args
  const {
    id,
    name,
    type,
    email,
    limitedAccess,
    surname,
    enabled,
    username,
    courierFilter,
    territoryFilter: territoryFilterValue,
    isCompanyFiltered,
    companies: companiesValue,
    drivers,
    vehicles,
  } = formValues
  let territoryFilter: string[]

  const companies = companiesValue.map(company => company.id)

  switch (type) {
    case 'courier':
      territoryFilter = courierFilter
      break

    default:
      territoryFilter =
        limitedAccess === false ? ['*'] : territoryFilterValue.map(territory => territory.id)
      break
  }

  const courierFilterData = (courierFilter || []).reduce<Record<string, CourierFilterEntry>>(
    (acc, filterId) => {
      const driverIds = drivers?.[filterId]?.ids || []
      const vehicleIds = vehicles?.[filterId]?.ids || []

      acc[filterId] = {
        driverIds: driverIds.length > 0 ? driverIds : ['*'],
        vehicleIds: vehicleIds.length > 0 ? vehicleIds : ['*'],
      }

      return acc
    },
    {},
  )

  const baseParams = {
    id,
    name,
    enabled,
    surname,
    username,
    email,
    territoryFilter,
    settings: userConfiguration,
    uiData: uiSettings ?? {
      version: 1 as const,
      exportOrders: {
        format: 'CSV' as 'CSV' | 'XLSX',
        includeBarcodes: true,
      },
      exportRoutes: {
        format: 'CSV' as 'CSV' | 'XLSX',
        includePod: true,
        includeBarcodes: true,
        loads: [],
        customFields: [],
      },
      weekStartsOn,
    },

    // by default this parameters are always present
    isCompanyFiltered,
    companies,
  }

  const user: uui.domain.actions.rpc.user.UpdateUserAction['payload']['user'] =
    type === 'courier'
      ? {
          type,
          ...baseParams,
          courierFilter: courierFilterData,
        }
      : { type, ...baseParams }

  return {
    user,
  }
}
